import { CircularProgress, Fab, Theme, withStyles } from '@material-ui/core'
import i18n from 'i18next'
import { FC, useState } from 'react'
import { CreateApartment } from '../../../actions/types'
import { getCurrentLanguage } from '../../../translations/i18n'
import { MuiClasses } from '../../../types'

const styles = ({ breakpoints, spacing }: Theme) => {
  const inlineButtonQuery = breakpoints.down(1065)
  const desktopButtonQuery = breakpoints.up(1066)

  return ({
    fabDivTop: {
      zIndex: 999,
      display: 'none',
      [inlineButtonQuery]: {
        display: 'block',
        width: '100%',
        maxWidth: 370,
        margin: '0 auto',
        '& button': {
          padding: '6px',
          width: '100%'
        },
        [breakpoints.down('sm')]: {
          maxWidth: 400
        }
      }
    },
    fabDivBottom: {
      zIndex: 999,
      height: '36px',
      display: 'none',
      [desktopButtonQuery]: {
        display: 'inline-block',
        position: 'fixed' as const,
        bottom: spacing(2),
        right: spacing(3)
      }
    },
    fab: {
      minWidth: '180px',
      padding: '0 30px',
      height: '36px !important',
      borderRadius: '4px !important',
      backgroundColor: '#fff',
      color: '#94004A',
      border: '1px dashed #94004A',
      boxShadow: 'none',
      '&::after': {
        display: 'none'
      },
      '&:hover': {
        color: '#670033',
        borderColor: '#670033',
        backgroundColor: '#fff'
      },
      [inlineButtonQuery]: {
        width: '100%',
        minWidth: 'auto',
        height: '46px !important',
        marginTop: '0.6rem'
      }
    },
    applicantsButton: {
      zIndex: 999,
      display: 'flex',
      justifyContent: 'center',
      width: '320px',
      [desktopButtonQuery]: {
        width: '320px',
        maxWidth: 'none',
        position: 'fixed' as const,
        top: '85px',
        right: getCurrentLanguage() == 'en' ? '142px' : '163px'
      },
      [breakpoints.up('md')]: {
        top: '85px',
        right: getCurrentLanguage() == 'en' ? '145px' : '167px'
      },
      [breakpoints.up('lg')]: {
        top: '85px',
        right: getCurrentLanguage() == 'en' ? '148px' : '170px'
      },
      [inlineButtonQuery]: {
        width: '100%',
        maxWidth: 370,
        margin: '0 auto',
        position: 'static',
        top: 'auto',
        right: 'auto',
        [breakpoints.down('sm')]: {
          maxWidth: 400
        }
      }
    },
    centerHorizontally: {
      display: 'flex',
      justifyContent: 'center',
    },
    addApt: {
      width: '100%',
    },
    buttonLabel: {
      display: 'inline-flex',
      alignItems: 'center',
      fontWeight: 600
    },
    plusSign: {
      fontSize: '1.4rem',
      lineHeight: 1,
      marginRight: '8px'
    }
  })
}

interface UserApartmentsToolbarProps {
  classes: MuiClasses
  createApartment: CreateApartment
  t: i18n.TFunction
}

const UserApartmentsToolbar: FC<UserApartmentsToolbarProps> = ({
  classes,
  t,
  createApartment
}) => {
  const [isLoading, setIsLoading] = useState(false)
  return (
    <div className={`${classes.container} ${classes.centerHorizontally}`}>
      <div className={classes.addApt}>
        <span className={classes.applicantsButton}>
          <span className={classes.fabDivTop}>
            <Fab
              color='default'
              variant='extended'
              className={classes.fab}
              onClick={() => {
                setIsLoading(true)
                createApartment()
              }}
            >
              {isLoading ? (
                <>
                  <CircularProgress
                    size={18}
                    style={{ color: '#94004A', marginLeft: '5px' }}
                  />
                </>
              ) : (
                <span className={classes.buttonLabel}>
                  <span className={classes.plusSign}>+</span>
                  {t('profile.createApartment')}
                </span>
              )}
            </Fab>
          </span>
        </span>

        <span className={classes.fabDivBottom}>
          <Fab
            color='default'
            variant='extended'
            className={classes.fab}
            onClick={() => {
              setIsLoading(true)
              createApartment()
            }}
          >
            {isLoading ? (
              <>
                <CircularProgress
                  size={18}
                  style={{ color: '#94004A', marginLeft: '5px' }}
                />
              </>
            ) : (
              <span className={classes.buttonLabel}>
                <span className={classes.plusSign}>+</span>
                {t('profile.createApartment')}
              </span>
            )}
          </Fab>
        </span>
      </div>
    </div>
  )
}

export default withStyles(styles)(UserApartmentsToolbar)
